<button
  mat-button
  (click)="clicked.emit()"
  [disabled]="disabled()"
  [type]="type()"
  [matTooltip]="tooltip()"
  [matTooltipPosition]="tooltipPosition()"
>
  <div class="content-wrapper">
    <ui-icon [faName]="currentIconName()" [faStyle]="currentIconStyle()" [animation]="currentAnimationName()"></ui-icon>
    <ng-content></ng-content>
  </div>
</button>